import { PropsWithChildren } from "react";

export default function ActionsColumn({ children }: PropsWithChildren) {
  if (!children) return <div className="w-4.5" />;

  return (
    <div className="w-4.5 flex flex-col justify-between items-center p-1 bg-slate-50 rounded-tr-sm rounded-br-sm">
      {children}
    </div>
  );
}
